import { Component, OnInit, Input } from '@angular/core';
import { Subscription, Observable } from "rxjs/Rx";
import { BusyLoaderService } from "app/shared/components/busy-loader.service";

@Component({
    selector: 'app-busy-loader',
    templateUrl: './busy-loader.component.html',
    styleUrls: ['./busy-loader.component.css']
})
export class BusyLoaderComponent implements OnInit {

    @Input() Loading: boolean = false;
    LoadingText: string = "Launching";

    LoadingTextSubscription: Subscription;
    NextLoadingObservableSubscription: Subscription;

    LoadingObservable: Observable<any>;
    LoadingObservableSubscription: Subscription;

    constructor(private busyLoaderService: BusyLoaderService) { }

    ngOnInit() {
        this.busyLoaderService.SetLoadingText("Launching");
        this.LoadingTextSubscription = this.busyLoaderService.LoadingText.subscribe((value: string) => {
            this.LoadingText = value;
        });

        this.NextLoadingObservableSubscription = this.busyLoaderService.NextLoadingObservable.subscribe((ob: Observable<any>) => {
            this.AddObservable(ob);
        });
    }

    ngOnDestroy() {
        this.LoadingTextSubscription.unsubscribe();
        this.NextLoadingObservableSubscription.unsubscribe();
    }

    AddObservable(ob: Observable<any>) {
        this.Loading = true;
        if (this.LoadingObservable == null) {
            this.LoadingObservable = ob;
        } else {
            if (this.LoadingObservableSubscription)
                this.LoadingObservableSubscription.unsubscribe();
            this.LoadingObservable = Observable.concat(this.LoadingObservable, ob);
        }

        this.LoadingObservableSubscription = this.LoadingObservable.subscribe(
            (res) => {
                this.LoadingObservable = null;
                this.Loading = false;
            },
            (err) => {
                this.LoadingObservable = null;
                this.Loading = false;
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/busy-loader.component.ts